import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { deleteRateAction } from '../../../redux/actions/ratesActions';
import Button from '../../shared/buttons/Button';
import Modal from '../../shared/modal/Modal';

const DeleteRateModal = ({ onModalClose, onModalSubmit }) => {
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const rate = useSelector((state) => state.rates?.rate);

  const onSubmit = async () => {
    setLoading(true);
    await dispatch(deleteRateAction(rate.id));
    setLoading(false);
    onModalSubmit();
  };

  return (
    <Modal
      title={'Видалення оцінки вартості'}
      loading={loading}
      onClose={onModalClose}
      body={'Ви дійсно бажаєте видалити цю оцінку вартості?'}
      actionButton={<Button onClick={onSubmit} disabled={loading} variant={'primary'} children={'Видалити'} />}
    />
  );
};

export default DeleteRateModal;
